import { Components } from "@mui/material";

export const MuiIconButton: Components["MuiIconButton"] = {
  styleOverrides: {
    root: {},
  },
};
